export default __webpack_public_path__ + "static/MaisonNeue-DemiBold-8525e5c0d85f902123535c3c3bc54ad1.woff";